<template>
  <div id="collection">
    <Dialog ref="dialog" :config="config"></Dialog>
    <div class="ohead">
      <div class="left">
        <div class="myInput">
          <i class="el-icon-search"></i>

          <input type="text" :placeholder="this.$fanyi('请输入关键词搜索')" v-model="form.keywords"
            @keydown.enter="getGoodsLists" />

        </div>
        <button @click="getGoodsLists">{{ $fanyi('搜索') }}</button>
      </div>
      <div class="btns">
        <button @click="delGoods('', '', 'all')">
          {{ $fanyi('选中移出') }}
        </button>
      </div>
    </div>

    <div :class="tagLists.length > 0 ? 'tallys' : 'newTallys'" v-if="tagLists.length > 0">
      <span :class="item.titleChecked ? 'active' : ''" @click="tabBtnClick(item)" v-for="(item, index) in tagLists"
        :key="index" :title="item.tag_name">{{ item.tag_name }}</span>
    </div>

    <div class="goods" v-if="!Nodata" v-loading="loading">
      <div class="goodslist">
        <div class="newGoodsOpt" v-for="(item, index) in goodsList" :key="index">
          <input :checked="item.checked" type="checkbox" name="" id="" @click="item.checked = !item.checked"
            class="check-box" />
          <div class="oimg" @click="
            $fun.toCommodityDetails({
              goods_id: item.goods_id,
              shop_type: item.shop_type,
              mi_id: item.mi_id || '',
            })
            ">
            <el-image :src="item.image_url">
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
              <div slot="placeholder">
                <i class="el-icon-loading"></i>
              </div>
            </el-image>
          </div>
          <div class="obtns">
            <span @click.stop="goodsTagOpen(item)" @mouseenter="changeImageSrc(1, 'hover', item)"
              @mouseleave="changeImageSrc(1, '', item)"> <img :src="item.labelUrl" alt="" />{{
                $fanyi('选择标签') }}</span>
            <span @click="delGoods(index, item)" @mouseenter="changeImageSrc(2, 'hover', item)"
              @mouseleave="changeImageSrc(2, '', item)"> <img :src="item.deleteUrl" alt="" />
              {{ $fanyi('删除') }}</span>
          </div>
          <div class="otitle">
            <el-popover placement="bottom" width="300" trigger="hover">
              {{ item.title }}
              <div class="showGoodsTitle" slot="reference">
                <div class="title">
                  {{ item.title }}
                </div>
              </div>
            </el-popover>

          </div>
          <div class="odetail">
            <div class="oprice">
              <div>
                ₴{{
                  $fun.EURNumSegmentation(
                    $fun.ceil(item.price * $store.state.exchangeRate)
                  )
                }}
                <span> (￥{{ $fun.RMBNumSegmentation(item.price) }})</span>
              </div>

            </div>
            <!-- 添加标签弹窗 -->
            <div class="tagListEditContainer">
              <el-dialog :visible.sync="dialogVisible" width="640px" :show-close="false" :before-close="handleClose">
                <div class="tagListEditHeaderContainer flexAndCenter">
                  <div>{{ $fanyi('选择标签') }}</div>
                  <i class="el-icon-close" @click="dialogVisible = false"></i>
                </div>
                <div class="tagListEditCenterContainer">
                  <div class="tagListEditCenterChildrenHeader flexAndCenter">
                    <div class="addKeyWord flexAndCenter">
                      <el-input :class="{ isChinese: isChinese }" :placeholder="$fanyi('请输入关键词')" v-model="addTagTxt"
                        @keydown.enter="addTag(item)">
                        <template slot="append">
                          <div @click="addTag(item)">
                            {{ $fanyi('新增') }}
                          </div>
                        </template>
                      </el-input>
                    </div>
                    <div class="removeTagBtn" @click="delTag()">
                      <img src="../../../../assets/newassets//collection/delete1.svg" alt="">
                      {{ $fanyi('移除') }}
                    </div>
                  </div>
                  <div class="tagListEditCenterChildrenFooter">
                    <div v-for="(item, index) in tagLists" :key="index" class="flexAndCenter">
                      <input type="checkbox" :checked="item.checked" @click="item.checked = !item.checked" name="" id=""
                        class="che" /><span :title="item.tag_name">{{ item.tag_name }}</span>
                    </div>
                  </div>
                </div>
                <span slot="footer" class="dialog-footer flexAndCenter">
                  <el-button @click="saveTag">{{ $fanyi('确认') }}</el-button>
                  <el-button type="primary" @click="dialogVisible = false">{{
                    $fanyi('取消')
                  }}</el-button>
                </span>
              </el-dialog>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 没有商品 -->
    <div class="Nodata" v-else>

      <div class="NodataImg">
        <img src="../../../../assets/defaulticon/favorite.svg" alt="">
      </div>

      <div class="NodataText">

        {{ $fanyi('暂无商品') }}
      </div>

    </div>
    <div class="allpag">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="form.page"
        :page-sizes="[10, 20, 30, 50]" layout="total,prev, pager, next,jumper" :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import Dialog from '../../../../components/public/Dialog.vue'

export default {
  data() {
    return {
      dialogVisible: false,

      tagLists: [], //标签列表
      goodsList: [], //收藏商品列表
      addTagTxt: '', //添加标签的文本
      loading: false,
      Nodata: false,
      goodsId: 0,
      total: 0,
      form: {},
      isChinese: localStorage.getItem('languagetype') == 'Chinese' ? true : false,
      goodsListLength: 0,
      config: {
        top: '20vh',
        width: '500px',
        title: this.$fanyi('提示'),
        btnTxt: [this.$fanyi('删除'), this.$fanyi('取消')],
      }, // 弹框属性
    }
  },
  components: {
    Dialog,
  },
  computed: {},
  created() {
    this.form.pageSize = 12
    this.getTagData()
    this.getGoodsLists()
  },
  mounted() {
    document.addEventListener('click', this.bodyCloseMenus)
  },
  methods: {
    // 删除商品
    delGoods(index, item, type) {
      var ids = []
      this.goodsList.forEach((item) => {
        if (item.checked == true) {
          ids.push(item.id)
        }
      })
      var idsstr = ids.join(',')

      if (ids.length == 0 && type == 'all') {
        return this.$message.warning(this.$fanyi('请至少选择一个商品'))
      }

      this.$refs.dialog.open(
        this.$fanyi('是否删除选中的商品'),
        (cancel) => {
          this.$api
            .favoriteGoodsDelete(
              type == 'all' ? { id: idsstr } : { id: item.id }
            )
            .then((res) => {
              if (res.code != 0) return
              if (
                Number(this.total) % Number(this.form.pageSize) == 1 &&
                this.form.page >
                parseInt(Number(this.total) / Number(this.form.pageSize))
              ) {
                this.form.page--
              }
              cancel()
              this.getGoodsLists()
              this.getTagData()
              setTimeout(() => {
                this.$store.dispatch('getLeftSidebarNum')
              }, 2000)
            })
        },
        () => { }
      )
    },
    // 添加商品标签
    async addTag(item) {
      this.$api
        .favoriteTagAdd({
          type: 1,
          tag_name: this.addTagTxt,
        })
        .then((res) => {

          if (res.code != 0) return
          this.addTagTxt = ''
          // 重新获取标签列表
          this.$api.favoriteTagList({ type: '1' }).then((res) => {
            this.tagLists = res.data
            // 调用处理标签列表事件
            this.tagDataProcessing()
            this.$forceUpdate()
          })
        })
    },
    //鼠标移入移出
    changeImageSrc(key, way, item) {
      switch (key) {
        case 1:
          way === 'hover'
            ? (item.labelUrl = require('../../../../assets/newassets/collection/label2.svg'))
            : (item.labelUrl = require('../../../../assets/newassets/collection/label1.svg'))
          break
        case 2:
          way === 'hover'
            ? (item.deleteUrl = require('../../../../assets/newassets/collection/delete2.svg'))
            : (item.deleteUrl = require('../../../../assets/newassets/collection/delete1.svg'))
          break
      }
    },
    // 删除商品标签
    delTag() {
      this.tagLists.forEach((item, index) => {
        if (item.checked === true) {
          this.$api
            .favoriteTagDelete({
              tag_id: item.tag_id,
            })
            .then((res) => {
              if (res.code != 0) return
              this.tagLists.splice(index, 1)
            })
        }
      })
    },
    handleClose(done) {
      done()
    },
    // 全局鼠标点击事件
    bodyCloseMenus() {
      // 关闭所有商品的标签弹窗
      this.goodsList.forEach((item) => { })
      this.$forceUpdate()
    },
    //保存选中商品的tag信息
    saveTag() {
      let ids = []
      this.tagLists.forEach((item) => {
        if (item.checked) ids.push(item.tag_id)
      })
      ids = ids.join(',')
      let datas = {
        id: this.goodsId,
      }
      if (ids) {
        datas.tag_ids = ids
      }
      this.$api.favoriteGoodsToTags(datas).then((res) => {
        this.dialogVisible = false
        if (res.code != 0) return
        this.getGoodsLists()
      })
    },
    //打开单个商品标签弹窗
    goodsTagOpen(item) {
      this.goodsId = item.id
      let goodsTagIds = item.tag_ids.split(',')
      // 初始化商品标签列表数据
      this.tagLists.forEach((item) => {

        if (goodsTagIds.indexOf(String(item.tag_id)) != -1) {
          item.checked = true
        } else {
          item.checked = false
        }
      })
      this.dialogVisible = true
      this.$forceUpdate()
    },
    // 标签按钮点击事件
    tabBtnClick(item) {
      // 设置选中便签的值
      item.titleChecked = !item.titleChecked
      this.form.page = 1
      this.getGoodsLists('tagGoods')
    },
    // 获取商品收藏夹标签列表并调用商品收藏夹列表获取函数
    getTagData() {
      this.$api.favoriteTagList({ type: '1' }).then((res) => {

        this.tagLists = res.data
        // 调用处理标签列表事件
        this.tagDataProcessing()
        // 调用获取商品收藏夹列表事件
      })
    },
    // 获取商品收藏夹列表
    async getGoodsLists(type) {
      this.loading = true
      let datas = {
        pageSize: this.form.pageSize,
        page: this.form.page,
        keywords: this.form.keywords,
      }
      let tagIds = []
      // 如果有筛选就循环遍历获取选中的标签id传给接口

      this.tagLists.forEach((item) => {
        if (item.titleChecked) tagIds.push(item.tag_id)
      })
      tagIds = tagIds.join(',')
      datas.tag_ids = tagIds

      await this.$api.favoriteGoodsList(datas).then((res) => {

        this.loading = false
        res.data.data.forEach((item) => {
          item.labelUrl = require('../../../../assets/newassets/collection/label1.svg')
          item.deleteUrl = require('../../../../assets/newassets/collection/delete1.svg')
        })
        if (!res.data.data || res.data.data.length == 0) {
          this.Nodata = true
        } else {
          this.Nodata = false
        }
        this.goodsList = res.data.data
        this.total = res.data.total
        this.goodsListLength = res.data.total
      })
      this.dataProcessing()
    },
    // 处理收藏夹标签数据
    tagDataProcessing() {
      this.tagLists.forEach((item) => {
        item.checked = false
        item.titleChecked = false
      })
    },
    // 处理收藏夹商品数据
    dataProcessing() {
      this.goodsList.forEach((item) => {
        item.checked = false
      })
    },
    handleSizeChange(val) {
      this.form.page_num = val
      this.form.page = 1
      this.getGoodsLists()
    },
    handleCurrentChange(val) {
      this.form.page = val
      this.getGoodsLists()
    },
  },
}
</script>
<style>
.el-popover {
  width: 330px;
  padding: 20px;
  background: #ffffff;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  border: 1px solid #dfdfdf;
}
</style>
<style lang="scss" scoped>
#collection {
  @import '../../../../css/mixin';
  width: 1060px;
  background: #FFFFFF;
  border-radius: 20px;
  padding: 30px 20px;
  padding-bottom: 10px;

  .ohead {
    display: flex;
    justify-content: space-between;
    align-items: center;


    .left {
      display: flex;
      align-items: center;

      .myInput {
        width: 400px;
        height: 40px;
        border-radius: 12px;
        position: relative;
        display: flex;
        align-items: center;
        // overflow: hidden;
        margin-right: 20px;

        >i {
          width: 20px;
          height: 24px;
          margin: 9px 11px 9px 12px;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #A2A2A2;
          position: absolute;
        }

        >input {
          border: 1px solid #e2e2e2;
          width: 100%;
          height: 100%;
          border-radius: 12px;
          font-size: 14px;
          padding-left: 40px;
          padding-right: 10px;
          transition: 0.3s;

          &:focus {
            border-color: #ff730b;
          }

          &::placeholder {
            color: #9a9a9a;
          }
        }


      }

      button {
        min-width: 80px;
        display: flex;
        align-items: center;
        justify-content: center;

        height: 40px;
        background: #D12A1D;
        font-weight: 400;
        font-size: 16px;
        color: #FFFFFF;
        border-radius: 12px;
      }
    }


    .btns {
      >button {
        min-width: 210px;
        height: 40px;
        border-radius: 12px;
        border: 1px solid #D12A1D;
        font-weight: 400;
        font-size: 16px;
        color: #D12A1D;
        line-height: 20px;
      }
    }
  }



  .tallys,
  .newTallys {
    margin-top: 20px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    span {

      height: 28px;
      background: #FAE9E8;
      border-radius: 8px;
      border: 1px solid #EDAAA5;

      font-weight: 400;
      padding: 0 8px;
      display: flex;
      font-size: 14px;
      align-items: center;
      justify-content: center;
      margin-right: 10px;

      color: #D12A1D;
      margin-bottom: 10px;

      &:hover {
        cursor: pointer;
      }

      &.active {
        background: #D12A1D;
        border-radius: 8px;
        color: #FFFFFF;
        border: 1px solid #D12A1D;
      }
    }
  }


  .goods {

    .goodslist {
      padding: 20px 0px;
      padding-bottom: 0px;
      display: flex;
      flex-wrap: wrap;
      min-height: 200px;

      .newGoodsOpt {
        width: 240px;
        min-height: 360px;
        background: #ffffff;
        border-radius: 12px;

        position: relative;
        margin-right: 20px;
        margin-bottom: 18px;

        &:nth-child(4n) {
          margin-right: 0 !important;
        }



        input[type='checkbox'] {
          background-color: #fff;
          -webkit-appearance: none;
          border: 1px solid #c0c4cc;
          border-radius: 6px;
          outline: none;
        }

        input[type='checkbox']:checked {
          background-color: #e40000;

          border: 1px solid #e40000;

          &::after {
            height: 4px;
            // 放大
            width: 9px;


          }
        }

        .check-box {
          width: 20px;
          height: 20px;
          background-color: #ffffff;
          border: solid 1px #dddddd;
          -webkit-border-radius: 50%;
          border-radius: 50%;

          position: absolute;
          left: 10px;
          top: 10px;
          z-index: 99;


        }

        .oimg {
          width: 240px;
          height: 240px;
          background: #F5F5F5;
          border-radius: 12px;
          border: 1px solid #DFDFDF;
          overflow: hidden;

          /deep/.el-image {
            $imgSize: 240px;
            width: 100%;
            width: 240px;
            height: 240px;
            background: #F5F5F5;
            border-radius: 12px;
            transition: 0.3s;
            text-align: center;
            margin-bottom: 3px;


            &:hover {
              transform: scale(1.2);
            }

            i {
              font-size: $imgSize/4;
              line-height: $imgSize;
            }
          }
        }

        .obtns {
          display: flex;
          justify-content: space-between;
          margin-top: 15px;
          margin-bottom: 10px;
          min-height: 20px;

          span {

            display: flex;
            align-items: center;
            font-weight: normal;
            font-size: 14px;
            color: #999999;
            line-height: 16px;

            &:hover {
              cursor: pointer;

              color: #D12A1D;

              img {
                transform: scale(1.2);
              }
            }

            img {
              width: 14px;
              height: 14px;
              margin-right: 5px;

            }

          }
        }

        .otitle {
          width: 220px;
          font-size: 14px;

          font-weight: 500;
          font-size: 14px;
          color: #121212;
          color: #121212;
          line-height: 16px;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          margin-bottom: 5px;
        }

        .odetail {


          .oprice {
            font-weight: bold;
            font-size: 18px;
            color: #121212;
            line-height: 24px;

            span {
              font-weight: normal;
              font-size: 12px;
              color: #999999;
            }


          }
        }
      }
    }


  }

  .tishi {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 300px;
    font-size: 25px;
    font-weight: bold;
    color: #bcb8b8;
  }

  .allpag {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 30px 0px;

    .el-pagination {
      display: flex;
      align-items: center;
    }

    >a {
      display: inline-block;
      border: 1px solid #dcdfe6;
      height: 28px;
      // background-color: white;
      text-align: center;
      padding: 0 10px;
      font-size: 13px;
      line-height: 28px;
      border-radius: 0;
    }

    /deep/.btn-prev {
      width: 30px;
      height: 30px;
      background: #FFFFFF;
      border-radius: 8px;
      border: 1px solid #DFDFDF;
      padding: 0;
      margin-right: 15px;
      margin-left: 20px;

      .el-icon {
        font-size: 16px;
        color: #000000;
      }
    }

    /deep/.btn-next {
      width: 30px;
      height: 30px;
      background: #FFFFFF;
      border-radius: 8px;
      border: 1px solid #DFDFDF;
      padding: 0;
      margin-left: 15px;



      .el-icon {
        font-size: 16px;
        color: #000000;
      }
    }

    /deep/ .el-pagination__jump {

      .el-input {
        width: 50px;
        height: 30px;
        background: #FFFFFF;
        border-radius: 8px;
        margin-left: 5px;

        font-weight: 400;
        font-size: 14px;
        color: #000000;

        .el-input__inner {
          height: 30px;
          border-radius: 8px;
        }
      }
    }

    /* 分页被选中的页码样式 */
    /deep/ .el-pager li {
      margin: 0 5px;
      width: 30px;
      line-height: 30px;
      height: 30px;
      border-radius: 8px;
      // box-shadow: 0 0 6px 0 rgba(61, 61, 61, 0.1);

      &:hover {
        color: #D12A1D;
      }

      &.active {
        width: 30px;

        height: 30px;
        background: #D12A1D;
        line-height: 30px;
        color: #fff;
        border-radius: 8px;
      }
    }
  }
}

.Nodata {
  display: flex;
  align-items: center;
  height: 320px;
  padding-top: 58px;
  flex-direction: column;

  .NodataImg {
    width: 160px;
    height: 160px;

    img {
      width: 100%;
      height: 100%;
    }


    margin-bottom: 30px;
  }

  .NodataText {
    font-weight: normal;
    font-size: 24px;
    color: #121212;
    line-height: 20px;
  }

}

.tagListEditContainer {


  /deep/.el-dialog {
    width: 640px;

    background: #FFFFFF;
    border-radius: 20px;
  }

  /deep/ .el-dialog__header {
    display: none;
  }

  /deep/ .el-dialog__body {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  /deep/ .el-dialog__header,
  /deep/ .el-dialog__body,
  /deep/.el-dialog__footer {
    padding: 0;
    border-radius: 10px;
  }

  .tagListEditHeaderContainer {
    height: 70px;
    padding-left: 40px;
    padding-right: 30px;
    box-sizing: border-box;
    align-items: flex-end;

    justify-content: space-between;

    div {
      font-weight: 600;
      font-size: 16px;
      color: #121212;
      line-height: 20px;
    }

    .el-icon-close {
      color: #000000;
      font-weight: bold;
      margin-bottom: 20px;
      font-size: 24px;
    }
  }

  .tagListEditCenterContainer {
    padding: 0 40px;
    padding-top: 30px;



    .tagListEditCenterChildrenHeader {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .addKeyWord {
        width: 434px;
        height: 50px;



        .el-input {
          // width: 434px;
          height: 50px;
          background: #FFFFFF;
          border-radius: 12px;
          border: 1px solid #DFDFDF;

          display: flex;

          align-items: center;

          /deep/ .el-input__inner {
            flex: 3.2;
            // border: 1px solid #cdcdcd;
            // background: #fff2e8;
            border: 0 !important;
            border-right: none;
            // border-radius: 0;

          }



          /deep/.el-input-group__append {
            // max-width: 125px;
            height: 40px;
            flex: 1;
            background: #D12A1D;

            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 5px;
            border-radius: 10px;
            font-size: 14px;
            border: none;

            &:hover {
              cursor: pointer;
            }

            color: #FFFFFF;
          }
        }

        .isChinese {

          /deep/.el-input__inner {
            flex: 12;
            // border: 1px solid #cdcdcd;
            // background: #fff2e8;
            border: 0 !important;
            border-right: none;
            // border-radius: 0;

          }
        }
      }

      .removeTagBtn {
        width: 106px;
        height: 50px;
        background: #FFFFFF;
        border-radius: 12px;
        display: flex;
        align-items: center;

        img {
          margin-right: 10px;
        }

        &:hover {
          cursor: pointer;
        }

        justify-content: center;
        border: 1px solid #DFDFDF;
      }
    }

    .tagListEditCenterChildrenFooter {
      display: flex;
      flex-wrap: wrap;
      margin-top: 30px;


      div {
        margin-bottom: 20px;
        margin-right: 40px;


        input[type='checkbox'] {
          width: 20px;
          height: 20px;
          border-radius: 6px;
          // border: 1px solid #cdcdcd;
        }

        span {
          display: inline-block;
          color: #222222;
          font-size: 14px;
          width: 120px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          margin-left: 6px;
        }
      }
    }
  }

  .dialog-footer {
    height: 100px;
    padding: 30px 40px;
    justify-content: center;


    button:first-child {
      width: 120px;
      height: 40px;
      background: #D12A1D;
      border-radius: 10px;
      display: flex;
      font-weight: 400;
      font-size: 14px;
      color: #FFFFFF;
      align-items: center;
      justify-content: center;
      border: none;
      margin-right: 10px;

    }

    .el-button+.el-button {
      margin-left: 0;
    }

    button:last-child {
      width: 120px;
      height: 40px;
      background: #FFFFFF;
      font-weight: 400;
      font-size: 14px;
      color: #222222;
      border-radius: 10px;
      border: 1px solid #DFDFDF;
    }
  }
}
</style>
